import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import axios from "axios";

const ProductDetail = () => {
  const [product, setProducts] = useState({});
  const [isInWishlist, setIsInWishlist] = useState(false);
  const history = useHistory();
  const { id } = useParams();
  const [quantity, setQuantity] = useState(1);
  const [isInCart, setIsInCart] = useState(true);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
  }, [product.id]);

  const viewProduct = () => {
    axios
      .post(`${BASE_URL}/api/product_image/view`, { id: id })
      .then((response) => {
        if (response.data.product) {
          setProducts(response.data.product);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    viewProduct();
  }, []);

  return (
    <main className="main-content site-wrapper-reveal">
      {/* <!--== Start Page Title Area ==--> */}
      <section
        className="page-title-area"
        data-bg-img="assets/img/photos/bg-page-title.webp"
        style={{ backgroundImage: `url("../assets/img/brand-board.webp")` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-title-content text-center">
                <h2 className="title text-white">
                  {product.product_image_id}. {product.product_image_name}
                </h2>
                <div className="bread-crumbs">
                  <Link to="/">
                    Home<span className="breadcrumb-sep ">/</span>
                  </Link>
                  <span className="active">{product.product_image_name}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--== End Page Title Area ==--> */}

      {/* <!--== Start Shop Area ==--> */}
      <section className="product-area shop-single-product">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="single-product-slider">
                <div className="single-product-thumb">
                  <div className="zoom zoom-hover">
                    <div className="thumb-item">
                      <Link
                        className="lightbox-image"
                        data-fancybox="gallery"
                        to="assets/img/shop/details/d1.webp"
                      >
                        <img
                          src={`${BASE_URL}/${product.product_image}`}
                          alt="Image-HasTech"
                          style={{ height: "60vh", width: "100%" }}
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mt-25">
              <div className="single-product-info">
                <h4 className="title">{product.product_image_name}</h4>

                <div
                  className="product-desc"
                  dangerouslySetInnerHTML={{
                    __html: product.product_description || "",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--== End Shop Area ==--> */}

      {/* <!--== Start Shop Tab Area ==--> */}
      <section className="product-area product-description-review-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-description-review"></div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--== End Shop Tab Area ==--> */}
    </main>
  );
};
export default ProductDetail;
